import { OrderFormState } from "../orderForm/state/OrderFormState";

export type BatchOrderLineLifecycleStatus = "prepare" | "loading" | "done" | "failed";

export interface BatchOrderLineState<TRow> {
  orderState: OrderFormState;
  lifecycleStatus: BatchOrderLineLifecycleStatus;
  row: TRow;
}

export const updateByRows = <TKey, TRow>(
  current: Map<TKey, BatchOrderLineState<TRow>>,
  rows: TRow[],
  rowToId: (row: TRow) => TKey,
  rowToState: (row: TRow) => OrderFormState,
) =>
  new Map(
    rows.map((row): [TKey, BatchOrderLineState<TRow>] => {
      const rowId = rowToId(row);

      return [
        rowId,
        current.get(rowId) ?? {
          orderState: rowToState(row),
          row: row,
          lifecycleStatus: "prepare",
        },
      ];
    }),
  );
